<script lang="ts" setup>
	const { replace } = useRouter()
	const activePlatform = shallowRef(0)
	const currentPathName = computed(() => useRoute().name)
	const items = computed(() => [
		{
			key: 'business',
			label: activePlatform.value != 0 ? 'Go to Business' : 'Business',
			description: false
		},
		{
			key: 'individual',
			label: activePlatform.value === 1 ? 'Personal' : 'Go to Personal',
			description: false
		}
	])
	onMounted(() => {
		if (currentPathName.value === 'individual') {
			activePlatform.value = 1
		}
	})
	const changeRoute = (arg: number) => {
		if (arg === 1) {
			return replace('/individual')
		}
		replace('/')
	}
</script>
<template>
	<u-tabs
		v-model="activePlatform"
		:items="items"
		class="w-full custom-transition-2"
		:ui="{
			list: {
				background: 'bg-base-50 dark:bg-gray-900 !rounded-[100px] min-w-[280px]',
				marker: {
					background: 'bg-main dark:bg-base-700',
					rounded: 'rounded-[20px]'
				},
				tab: {
					active: 'text-white'
				}
			}
		}"
		@change="changeRoute"
	/>
</template>

<style></style>
